export const DayOfWeek = {
	ALL: 0,
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SARTURDAY: 6,
	SUNDAY: 7,
};
